// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"bao_a","InstagramEmbed__mask":"bao_b bhg_bi bhg_bo bhg_wx"};